<div class="payout-info">
    <div mat-dialog-title>
        <div class="failure-popup-header d-flex justify-content-end">
          <img
            src="assets/icon/cross.svg"
            (click)="onClose()"
            class="cursor-pointer"
            alt="close"
          />
        </div>
      </div>
    <div class="row">
      <div class="col-12 text-center">
        <div class="error-gif">
          <img src="assets/gif/error.gif" class="error-gif-image" alt="close" />
          <!-- <p class="text-orange gif-icon-text">Lorem Ipsum</p> -->
        </div>
      </div>
      <div class="col-12">
        <p class="attention text-center">ATTENTION</p>
      </div>
      <div class="col-12 d-flex justify-content-center">
        <div class="me-1">
          <p class="message">
            Information will be available soon, meanwhile refer to excel grid or contact your Relationship Manager.
          </p>
        </div>
      </div>
    </div>
  </div>